import { AnimatePresence } from 'framer-motion';
import { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-use';

import RouterLink from '@/react_app/common/RouterLink';
import RouterView from '@/react_app/common/RouterView';
import { AppMenu, MenuProps } from '@/react_app/components/Atoms';
import AnimateView from '@/react_app/components/BillingUsage/AnimateView';
import {
	BILLING_USAGE_HISTORY_AUTOMATION_ROUTE_NAME,
	BILLING_USAGE_HISTORY_PLY_CREDITS_ROUTE_NAME,
	BILLING_USAGE_HISTORY_TEAM_FEATURES_ROUTE_NAME,
	BILLING_USAGE_HISTORY_CUSTOMER_FEATURES_ROUTE_NAME,
} from '@/router/BillingUsage/billing-usage-router.const';
const items: MenuProps['items'] = [
	{
		key: 'team-features',
		label: (
			<RouterLink class="no-underline" to={{ name: BILLING_USAGE_HISTORY_TEAM_FEATURES_ROUTE_NAME }}>
				Team features
			</RouterLink>
		),
	},
	{
		key: 'customer-features',
		label: (
			<RouterLink class="no-underline" to={{ name: BILLING_USAGE_HISTORY_CUSTOMER_FEATURES_ROUTE_NAME }}>
				Customer features
			</RouterLink>
		),
	},
	{
		key: 'automation',
		label: (
			<RouterLink class="no-underline" to={{ name: BILLING_USAGE_HISTORY_AUTOMATION_ROUTE_NAME }}>
				Automation
			</RouterLink>
		),
	},
	{
		key: 'ply-credits',
		label: (
			<RouterLink class="no-underline" to={{ name: BILLING_USAGE_HISTORY_PLY_CREDITS_ROUTE_NAME }}>
				Ply Credits
			</RouterLink>
		),
	},
];

const defaultSelectedKey = items[0]?.key || 'team-features';

const SettingsUsageBillingUsageHistory = () => {
	const [current, setCurrent] = useState(defaultSelectedKey);
	const location = useLocation();
	useEffect(() => {
		const pathName = location.pathname;
		const pathNameParts = pathName?.split('/');
		setCurrent(pathNameParts?.at(-1) || defaultSelectedKey);
	}, [location, useLocation]);
	// @ts-ignore
	const selectedKeys: string[] = useMemo(() => [current], [current]);
	return (
		<AnimateView>
			<div>
				<AppMenu mode="horizontal" items={items} selectedKeys={selectedKeys} className="mb-[10px] pb-[10px] w-auto border-[#E0E2E7]" />
				<div className="mt-5">
					<AnimatePresence>
						<RouterView></RouterView>
					</AnimatePresence>
				</div>
			</div>
		</AnimateView>
	);
};

export default SettingsUsageBillingUsageHistory;
